import { Icon } from '@unite-us/app-components';

function ErrorPageNoResults() {
  const responseMessage = 'Sorry, it looks like something went wrong on our end. Try refreshing your browser.';

  const message = 'Something went wrong';

  return (
    <div className="error-page">
      <Icon
        className="error-page__icon"
        color="#182A44"
        icon="Warning"
        size={80}
      />
      <h1 className="error-page__message">{message}</h1>
      <span className="error-page__code">{responseMessage}</span>
    </div>
  );
}

export default ErrorPageNoResults;
